// Hard-coded member IDs for order administration.
// We probably need some new role/claims for this
export const allowedOrdersMemberIds = [
    684744, 358876, 345683, 636293, 607764, 358878,
];
export const canManageOrders = (user) => !!user.roles?.includes("federation:1") &&
    allowedOrdersMemberIds.includes(Number(user.sub));
//# sourceMappingURL=ordersAccess.js.map